module.exports = __webpack_public_path__ + "media/sessions/all_hands@1x-c954b45b.png";